import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SvgCaptcha from "../captcha";
import axiosInstance from "../../utils/axiosInstance";

const ResetPrasadDialog = ({ open, onClose, onConfirm }) => {
  const [captcha, setCaptcha] = useState("");
  const [reload, setReload] = useState(0);
  const [error, setError] = useState("");

  const handleVerifyAndConfirm = async () => {
    setError("");
    const res = await axiosInstance.post(
      "/captcha/verify",
      { captcha },
      { withCredentials: true }
    );

    if (!res.ok) {
      setError("Invalid CAPTCHA. Please try again.");
      setReload((r) => r + 1);
      return;
    }

    setCaptcha("");
    onConfirm();
  };
  return (
    <Dialog open={open} onClose={onClose}>
      <div
        className="modal-header"
        style={{
          background: "#1976D2",
          color: "white",
          fontWeight: "bold",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "16px",
          borderBottom: "1px solid #ddd",
        }}
      >
        <DialogTitle>Reset Prasad</DialogTitle>
        <IconButton onClick={onClose} color="dark" data-log="Close Icon Button">
          <CloseIcon sx={{ color: "white" }} />
        </IconButton>
      </div>
      <DialogContent>
        <Typography>
          Are you sure you want to reset all donors' Prasad <br />
          <b style={{ color: "green" }}>Yes </b> to{" "}
          <b style={{ color: "red" }}> No </b>?
        </Typography>
        <SvgCaptcha value={captcha} onChange={setCaptcha} error={error} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          No
        </Button>
        <Button
          onClick={handleVerifyAndConfirm}
          color="error"
          variant="contained"
          disabled={!captcha}
        >
          Yes, Reset
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ResetPrasadDialog;
